const builderTitle = line =>
  line?.node?.attributes?.find(attr => attr.key === '_bundle_builder')?.value || null;

export default function groupBuilderLines(lines) {
  const groups = new Map();
  return (lines || []).flatMap(line => {
    const title = builderTitle(line);
    if (!title) return [{ type: 'line', line }];
    const group = groups.get(title);
    if (group) {
      group.lines.push(line);
      return [];
    }
    const created = { type: 'group', title, lines: [line] };
    groups.set(title, created);
    return [created];
  });
}
